import {defineStore} from "pinia";
import axios from "axios";
import {useProductsStore} from './ProductsStore'
import {useOthStore} from './OthStore'
import moment from 'moment'
import Vue from "vue";

export const useUserStore = defineStore('UserStore', {
    state: () => {
        return {
            user: [],
            session: true,
            othform: {
                is_loading: false,
                result: false,
                message: '',
            },
            scan: {
                title: '',
                id: '',
                storehouse: '',
                position: 0,
                scan_code: '',
                result: '',
                count: 0,
            },
            orders: {
                items: {},
                have_checked: false,
                is_loading: false,
                input_nubmer: '',
                input_pr_code: '',
                input_status: '',
                input_s_date: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                input_e_date: moment().format('YYYY-MM-DD'),
                input_sort: '2',
                input_direction: 'desc',
                input_stock: 'stock_all'
            },
            info: {
                data: {},
                show: false,
                error: false,
                confirm: false,
                cancel: false,
                is_loading: false,
            },
            order: {
                fields: {
                    address: '',
                    date: '',
                    contact: '',
                    phone: '',
                    paid: '',
                    comment: '',
                },
                is_loading: false,
                message: '',
                success: false,
                error: false,
                adreses: [],
                contacts: [],
                notices: {},
            },
            fb: {
                fields: {
                    delivery: '',
                    name: '',
                    phone: '',
                    email: '',
                    comment: '',
                    message: '',
                },
                is_loading: false,
                success: false,
            },
            post1c: {
                fields: {
                    oldpassword: '',
                    newpassword: '',
                    newpasswordrepiad: '',
                },
                message: '',
                error: false,
                is_loading: false,
                settings_is_loading: false,
                success: false,
            },
            others: {
                contacts_is_loading: false,
                adress_is_loading: false,
            },
            config: [],
        }
    },
    actions: {
        async send_logout() {
            console.log('Отправляем запрос на выход');
            const jsonData = {};
            let reqResult = (await axios.get('/api/user_logout', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
                this.user.id = false;
            }
            return reqResult;
        },
        async save_to_session(string) {
            const params = new URLSearchParams();
            params.append('data', string);
            let reqResult = (await axios.post( '/api/save_in_session', params, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            } else {
                reqResult.type = 'error';
            }
            return reqResult;
        },
        async change_count_in_order(add_arr) {
            this.info.is_loading = true;
            const jsonData = {};
            jsonData.type = 'order_change';
            jsonData.ids = [this.info.data.order_num];
            jsonData.items = [];
            for (const index in this.info.data.items) {
                // Блокируем для изменения
                //console.log('here!');
                //console.log(index,this.info.data.items[index]);
                this.info.data.items[index].lock = true;

                // Удаление
                if (Number(index) === Number(add_arr.id) && add_arr.count === 0) {
                    console.log('Удаление для index: ' + index);
                    // TODO: возможно запись должна следовать здесь
                    jsonData.items.push(
                        {
                            str_num: Number(index) + 1,
                            count: 0,
                        }
                    );
                }
                // TODO: вероятно ветвление не нужно
                else if (Number(index) === Number(add_arr.id)) {
                    jsonData.items.push(
                        {
                            str_num: Number(index) + 1,
                            count: add_arr.count,
                        }
                    );
                } else {
                    jsonData.items.push(
                        {
                            str_num: Number(index) + 1,
                            count: Number(this.info.data.items[index].count),
                        }
                    );
                }
            }

            //console.log('Передаем новое кол-во в 1С');
            let reqResult = (await axios.post('/api/1c/orders?action=order_change', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';

            }

            this.fill_order_info(this.info.data.order_num);
            this.info.is_loading = false;

            return reqResult;
        },
        async change_delivery_settings() {

            const params = new URLSearchParams();
            params.append('type', 'change_delivery_zone');
            params.append('delivery_zone', this.user.delivery_zone);

            let reqResult = (await axios.post('/api/change_delivery_zone', params, {
                withCredentials: true,
            })).data;


            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {

                const ProductsStore = useProductsStore();
                ProductsStore.fill_search_params();

                this.fill();

                //this.send_logout();
            } else {
                Vue.prototype.$notifyInfo(reqResult.message);

            }

        },
        async change_u_settings() {
            this.post1c.settings_is_loading = true;
            const params = new URLSearchParams();

            params.append('demo_percent', this.user.demo_percent);
            params.append('demo_mode', this.user.demo_mode);
            params.append('demo_mrc', this.user.demo_mrc);

            let reqResult = (await axios.post('/api/change_demo_mode', params, {
                withCredentials: true,
            })).data;

            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';

                if( this.user.demo_mrc!==1 ){
                    const ProductsStore = useProductsStore();
                    ProductsStore.fill_products();
                }





                //this.send_logout();
            } else {
                console.log('Error on usersatm, answer:', reqResult);
                reqResult = {};
                reqResult.type = 'error';
                reqResult.message = 'Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру';
            }

            this.post1c.settings_is_loading = false;

            return reqResult;
        },


        async send_1c_changepass() {
            // TODO: доделать
            this.post1c.is_loading = true;
            const params = new URLSearchParams();

            params.append('type', 'changepassword');
            for (const index in this.post1c.fields) {
                params.append(index, this.post1c.fields[index]);
            }

            let reqResult = (await axios.post('/api/1c/usersatm', params, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
                for (const index in this.post1c.fields) {
                    this.post1c.fields[index] = '';
                }
            }
            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                this.post1c.error = true;
            }
            if (typeof (reqResult.message) != "undefined" && (reqResult.message !== null)) {
                this.post1c.message = reqResult.message;
            }

            // TODO: доделать

            console.log(reqResult);

            this.post1c.is_loading = false;

            return reqResult;
        },
        async send_del_contact(id) {
            this.others.contacts_is_loading = true;
            console.log('Удаление контакта: ' + id);
            const jsonData = {};
            jsonData.id = Number(id);
            jsonData.type = 'delete';
            let reqResult = (await axios.post( '/api/delete_contact', jsonData, {
                withCredentials: true,
            })).data;
            this.others.contacts_is_loading = false;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            return reqResult;
        },
        async send_del_delivery(adress_id) {
            this.others.adress_is_loading = true;
            const jsonData = {};
            jsonData.id = Number(adress_id);
            jsonData.type = 'delete';
            let reqResult = (await axios.post( '/api/delete_delivery', jsonData, {
                withCredentials: true,
            })).data;
            this.others.adress_is_loading = false;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            return reqResult;
        },
        async send_add_delivery() {
            this.fb.is_loading = true;
            const jsonData = {};
            for (const index in this.fb.fields) {
                jsonData[index] = this.fb.fields[index];
            }
            let reqResult = (await axios.post('/api/add_delivery', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            this.fb.is_loading = false;
            return reqResult;
        },
        async send_add_contact() {
            this.fb.is_loading = true;
            const jsonData = {};
            for (const index in this.fb.fields) {
                jsonData[index] = this.fb.fields[index];
            }
            let reqResult = (await axios.post( '/api/add_contact', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            this.fb.is_loading = false;
            return reqResult;
        },
        async send_fb() {
            this.fb.is_loading = true;
            const jsonData = {};
            for (const index in this.fb.fields) {
                jsonData[index] = this.fb.fields[index];
            }
            let reqResult = (await axios.post( '/api/feedback', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            this.fb.is_loading = false;
            return reqResult;
        },
        set_orders_checked_status() {
            let have_checked_status = false;
            for (const index in this.orders.items) {
                if (this.orders.items[index].checked === true) {
                    have_checked_status = true;
                }
            }
            this.orders.have_checked = have_checked_status;
        },
        async remove_order() {
            this.info.is_loading = true;
            const params = new URLSearchParams();
            params.append('type', 'order_cancel');
            params.append('ids[]', this.info.data.order_num);
            let reqResult = (await axios.post( '/api/1c/orders', params, {
                withCredentials: true,
            })).data;
            this.info.is_loading = false;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                this.info.cancel = true;
            }
            return reqResult;
        },
        async orders_cancel() {
            this.orders.is_loading = true;
            const params = new URLSearchParams();
            params.append('type', 'order_cancel');
            for (const index in this.orders.items) {
                if (this.orders.items[index].checked === true) {
                    //checked[index] = this.orders.items[index].id;
                    params.append('ids[]', this.orders.items[index].order_num);
                    //params.append('ids', this.orders.items[index].id);
                }
            }
            let reqResult = (await axios.post('/api/1c/orders', params, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            this.orders.is_loading = false
            await this.fill_user_orders()
            return reqResult;
        },
        async orders_combine() {
            this.orders.is_loading = true;
            const jsonData = {};
            jsonData.type = 'order_combine';
            jsonData.order_gen = '';
            jsonData.ids = [];
            for (const index in this.orders.items) {
                if (this.orders.items[index].checked === true) {
                    jsonData.ids.push(this.orders.items[index].order_num);
                }
            }
            let reqResult = (await axios.post('/api/1c/orders', jsonData, {
                withCredentials: true,
            })).data;
            if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success == true)) {
                reqResult.type = 'success';
            }
            this.orders.is_loading = false
            await this.fill_user_orders()
            return reqResult;
        },
        async fill_order_info(order_id) {

            this.info.error = false;
            this.info.is_loading = true;

            let reqResult = (await axios.get( '/api/1c/orderatm?id=' + order_id, {
                withCredentials: true,
            })).data;

            if (typeof (reqResult.order_id) != "undefined" && reqResult.order_id !== null) {
                this.info.data = reqResult;
                for (const index in this.info.data.items) {
                    this.info.data.items[index].lock = true;


                    if (this.info.data.items[index].state.match(/(К Обеспечению|Не Требуется|Со Склада|Резервировать По Мере Поступления)/gi)) {

                        this.info.data.items[index].lock = false;

                    }

                }
            } else {
                this.info.error = true;
                this.info.is_loading = false;
                return false;
            }
            this.info.is_loading = false;
            return reqResult;
        },
        async fill_user_orders() {

            let s_date = moment(this.orders.input_s_date, 'YYYY-MM-DD').format('DD-MM-YYYY');
            let e_date = moment(this.orders.input_e_date, 'YYYY-MM-DD').format('DD-MM-YYYY');
            this.orders.is_loading = true;
            const params = new URLSearchParams();
            params.append('start', 0);
            params.append('length', 100);

            params.append('order[0][column]', this.orders.input_sort);
            params.append('order[0][dir]', this.orders.input_direction);

            //params.append('input_nubmer', this.orders.input_nubmer);
            //params.append('input_pr_code', this.orders.input_pr_code);

            params.append('order_search_id', this.orders.input_nubmer);
            params.append('order_search_sku', this.orders.input_pr_code);

            params.append('input_status', this.orders.input_status);
            //params.append('order_search_date', s_date+'-'+e_date);
            params.append('order_search_date', s_date + ' - ' + e_date);
            //params.append('input_s_date', this.orders.input_s_date);
            //params.append('input_e_date', this.orders.input_e_date);
            //params.append('input_sort', this.orders.input_sort);
            //params.append('input_sort_dir', this.orders.input_direction);

            let reqResult = (await axios.post('/api/1c/orders', params, {
                withCredentials: true,
            })).data;

            if (reqResult.error === true && reqResult.message) {
                Vue.prototype.$notifyInfo(reqResult.message);
                this.orders.items = [];
            }


            if (typeof (reqResult.data) !== "object") {
                console.log('Error get User Orders');
            } else {
                for (const index in reqResult.data) {
                    // Назначаем статус "выбрано" по умолчанию
                    if (typeof (reqResult.data[index].checked) === "undefined" || reqResult.items[index].checked === null) {
                        reqResult.data[index].checked = false;

                        reqResult.data[index].order_num = reqResult.data[index].id;
                        reqResult.data[index].order_date = reqResult.data[index].created;
                        reqResult.data[index].order_sum = reqResult.data[index].sum;
                        reqResult.data[index].order_state_1c = reqResult.data[index].status;
                        reqResult.data[index].order_count = reqResult.data[index].col;

                    }
                }

                const orders = await this.setStockInOrders(reqResult);
                this.orders.items = this.normalizeStockInOrders(this.filterOrders(orders));
            }


            /*if(typeof(reqResult.items) !== "object") {
                console.log('Error get User Orders');
            }
            else {
                for (const index in reqResult.items)
                {
                    // Назначаем статус "выбрано" по умолчанию
                    if(typeof (reqResult.items[index].checked) === "undefined" || reqResult.items[index].checked === null)
                    {
                        reqResult.items[index].checked = false;
                    }
                }
                this.orders.items = reqResult.items;
            }*/


            this.orders.is_loading = false;


        },
        async getAllStocks() {
            try {
                const response = await axios.get('/api/get_stocks');
                const allStocks = response.data;
                if (allStocks.error) {
                    const errorMessage = allStocks.message ?? 'Неизвестная ошибка получения складов';
                    Vue.prototype.$notifyInfo(errorMessage);
                    throw new Error(errorMessage);
                } else {
                    return allStocks;
                }
            } catch (error) {
                const errorMessage = error.message ?? 'Ошибка при запросе к API';
                Vue.prototype.$notifyInfo(errorMessage);
                throw new Error(errorMessage);
            }
        },
        async setStockInOrders(orders) {
            try {
                const { data } = orders;
                const allStocks = await this.getAllStocks();
                return data.map((item) => {
                    for (const [stockName, stocksUidArray] of Object.entries(allStocks)) {
                        if (item.order_warehouse === '60f1469a-7c41-11e8-80d0-0025902e04b3') item.order_warehouse = 'КРАСНОДАР';
                        if (stocksUidArray.includes(item.order_warehouse)) item.order_warehouse = stockName;
                    }
                    return item;
                });
            } catch (error) {
                const errorMessage = error.message ?? 'Ошибка при установке складов в заказах';
                Vue.prototype.$notifyInfo(errorMessage);
                throw new Error(errorMessage);
            }
        },
        filterOrders(orders) {
            const stockFiltering = this.orders.input_stock;
            if ('stock_all' === stockFiltering) {
                return orders;
            }

            return orders.filter(order => order.order_warehouse === stockFiltering)
        },
        normalizeStockInOrders(orders) {
            return orders.map((order) => {
                order.order_warehouse = order.order_warehouse.charAt(0).toUpperCase() + order.order_warehouse.slice(1).toLowerCase();
                return order;
            })
        },
        async fill() {

            let reqResult = (await axios.get('/api/b2b_user', {
                withCredentials: true,
            })).data;

            if (reqResult.error === true) {
                this.user = false;
                return;
            }


            this.order.adreses.push('Самовывоз (Индустриальная, д. 4)');


            for (const index in reqResult.addresses) {
                this.order.adreses.push(reqResult.addresses[index].address.value);
            }

            this.order.contacts.push('Не установленно');

            for (const index in reqResult.contacts) {
                this.order.contacts.push(reqResult.contacts[index].contact_name + ', ' + reqResult.contacts[index].contact_phone + ', ' + reqResult.contacts[index].contact_mobile_phone + ', ' + reqResult.contacts[index].contact_email);
            }

            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                console.log('Error Get User Data');
            }

            this.user = reqResult;
            this.calc_web_basket();

            // this.user.basket_oth_web = {};
            // this.user.basket_oth_web.is_loading = true;

            //let reqResultOth = await this.update_oth_basket();
            // console.log(reqResultOth);

            //this.basket_oth_mutator();
            //this.calc_oth_web_basket();

            //await this.get_session_data();
        },


        async update_web_basket() {


        },


        calc_web_basket() {

            this.user.web_basket.count = 0;
            this.user.web_basket.summa = 0;

            for (const web_basket_index in this.user.web_basket.items) {
                this.user.web_basket.items[web_basket_index].sum = 0;
                if (this.user.web_basket.items[web_basket_index].count > 0) {
                    this.user.web_basket.items[web_basket_index].sum = Number(this.user.web_basket.items[web_basket_index].price * this.user.web_basket.items[web_basket_index].count);
                    this.user.web_basket.count++;
                    this.user.web_basket.summa += Number(this.user.web_basket.items[web_basket_index].price * this.user.web_basket.items[web_basket_index].count);
                }
            }


            this.user.web_basket_oth.count = 0;

            for (const web_basket_oth_index in this.user.web_basket_oth.items) {
                if (this.user.web_basket_oth.items[web_basket_oth_index].count > 0) {
                    this.user.web_basket_oth.count++;
                }
            }

            return true;

        },


        async change_count(index_in_storage, new_count) {
            //console.log('change_count 1',index_in_storage,new_count)
            for (const index in this.user.web_basket.items) {
                //console.log('change_count 2',index,index_in_storage,(index === Number(index_in_storage)))
                if (Number(index) === Number(index_in_storage)) {
                    //console.log('change_count',this.user.web_basket.items[index]);
                    this.user.web_basket.items[index].count = new_count;
                    this.user.web_basket.items[index].is_update = false;
                    this.user.web_basket.is_update = false;
                }
            }
            //this.calc_web_basket();
        },


        // Обновляем удаленные данные корзины на данные из локального хранилища
        async update_remote_basket() {
            const params = new URLSearchParams();
            for (const index in this.user.web_basket.items) {
                if (Number(this.user.web_basket.items[index].count) > 0) {
                    params.append('data[' + index + '][id]', this.user.web_basket.items[index].id);
                    params.append('data[' + index + '][count]', this.user.web_basket.items[index].count);
                } else {
                    // TODO: удаление
                }
            }
            let reqResult = (await axios.post( '/api/basket_change', params, {withCredentials: true})).data;
            if (typeof (reqResult.success) === "undefined" || reqResult.success === null || reqResult.success != true) {
                console.log('Error Update Remote Basket');
            } else {
                console.log('Успешное ПАКЕТНОЕ обновление кол-ва в удаленной корзине');
                reqResult.type = 'success';
            }

            this.calc_web_basket();
            // TODO: костыль для ухода от проблемы с неправильным кол-вом добавленных
            const ProductsStore = useProductsStore();
            ProductsStore.clear_search_keys();
            return reqResult;
        },

        async send_sale() {
            this.user.basket_oth_web.is_loading = true;
            this.othform.is_loading = true;
            console.log('send_sale:', this.user.basket_oth_web.is_loading);
            const params = new URLSearchParams();
            let reqResult = (await axios.post( '/api/basket_oth_sale', params, {withCredentials: true})).data;
            if (typeof (reqResult.success) === "undefined" || reqResult.success === null || reqResult.success != true) {
                console.log('Error OTH Sale');
            } else {
                reqResult.type = 'success';
                this.othform.result = true;
                this.othform.message = reqResult.message;
                // TODO: сначала отправить запрос на очистку корзины
                await this.update_oth_basket();
            }
            this.user.basket_oth_web.is_loading = false;
            this.othform.is_loading = false;
            return reqResult;
        },
        // Одиночное добаление в корзину - при передачи из поиска (ProductStore)
        async write_web_basket(add_arr, is_new = true) {


        },


        async remove_from_remote_basket(id, index_in_basket = null) {
            console.log('Удаление из удаленной корзины');
            const params = new URLSearchParams();
            params.append('id', id);
            let reqResult = (await axios.post( '/api/basket_remove', params, {withCredentials: true})).data;
            if (typeof (reqResult.success) === "undefined" || reqResult.success === null || reqResult.success != true) {
                console.log('Error Remove from Remote Basket');
            } else {
                console.log('Успешное удаление из удаленной корзины');
                reqResult.type = 'info';
                if (typeof (index_in_basket) !== "undefined" && index_in_basket !== null) {
                    //this.user.web_basket.items[index_in_basket].is_update = true;
                    this.user.web_basket.is_update = true; // TODO: сделать это проверкой по циклу, по всем позициям, если все обновлены только тогда присваивать
                }
            }
            this.calc_web_basket();
            return reqResult;
        },

        async update_count_in_remote_basket(add_arr, index_in_basket = null) {
            console.log('Обновление кол-ва в удаленной корзине');
            const params = new URLSearchParams();
            params.append('data[0][id]', add_arr.id);
            params.append('data[0][count]', add_arr.count);
            let reqResult = (await axios.post('/api/basket_change', params, {withCredentials: true})).data;
            if (typeof (reqResult.success) === "undefined" || reqResult.success === null || reqResult.success != true) {
                console.log('Error Update Remote Basket');
            } else {
                if (typeof (add_arr.index_s_results) !== "undefined" && add_arr.index_s_results !== null && typeof (add_arr.index_store) !== "undefined" && add_arr.index_store !== null) {
                    reqResult.index_s_results = add_arr.index_s_results;
                    reqResult.index_store = add_arr.index_store;
                    if (typeof (index_in_basket) !== "undefined" && index_in_basket !== null) {
                        this.user.web_basket.items[index_in_basket].is_update = true;
                        this.user.web_basket.is_update = true; // TODO: сделать это проверкой по циклу, по всем позициям, если все обновлены только тогда присваивать
                    }
                }

                console.log('Успешное обновление кол-ва в удаленной корзине');
                reqResult.type = 'success';
            }
            this.calc_web_basket();
            return reqResult;
        },

        async try_order() {
            // Индикация загрузки в UI
            this.order.is_loading = true;
            // Сброс результатов предыдущей отправки TODO: оформить в метод
            this.order.success = false;
            this.order.error = false;
            this.order.message = '';
            this.order.notices = {};
            // Формируем поля запроса для отправки
            const params = new URLSearchParams();
            params.append('type', 'order_create');
            for (const index in this.order.fields) {
                if (index === 'date' && this.order.fields[index].length >= 9) {
                    let date = moment(this.order.fields[index], 'YYYY-MM-DD').format('DD-MM-YYYY');
                    console.log('Date Debug', date);
                    params.append(index, date);
                } else {
                    params.append(index, this.order.fields[index]);
                }
            }
            // Отправляем запрос и ждем ответа TODO: необходимо обработчик сетевых ошибок
            let reqResult = (await axios.post('/api/order_create', params, {
                withCredentials: true,
            })).data;
            // Индицируем завешение обмена в UI
            this.order.is_loading = false;


            // Происводим разбор ответа - устанавливаем параметры для неудачного оформления
            if (typeof (reqResult.error) != "undefined" && (reqResult.error !== null) && (reqResult.error == true)) {
                // Устанавливаем тип ответа для логики UI
                reqResult.type = 'error';
                // Флаг наличия общибки для логики UI
                this.order.error = true;
                if (typeof (reqResult.message) == "undefined" || reqResult.message === null) {
                    reqResult.message = 'Неизвестная ошибка - обратитесь к менеджеру';
                } else {
                    this.order.message = reqResult.message; // TODO: Очистить если пользователь начинает наполнять корзину заново
                }
                if (typeof (reqResult.notice) != "undefined" && typeof (reqResult.notice) === "object" && reqResult.notice.length > 0) {
                    this.order.notices = reqResult.notice;
                }
            }

            // Происводим разбор ответа - успех
            else {
                if (typeof (reqResult.success) != "undefined" && (reqResult.success !== null) && (reqResult.success === true)) {
                    // Устанавливаем тип ответа для логики UI
                    reqResult.type = 'success';
                    // Флаг наличия общибки для логики UI
                    this.order.success = true; // TODO: назначить false если пользователь начинает наполнять корзину заново
                    // Проверяем наличие переданного сообщения - присваеваем
                    if (typeof (reqResult.message) != "undefined" && (reqResult.message !== null)) {
                        this.order.message = reqResult.message.replace(/(ВР00-[0-9]+)/gmi,"<a href='/panel/#/order_info/$1'>$1</a>");
                        var redirect = reqResult.message.match(/(ВР00-[0-9]+)/gmi);
                        setTimeout(function () {
                            document.location = '/panel/#/order_info/' + redirect[0];
                        },10000);
                    }
                    // Очищаем корзину
                    this.fill_user_orders()
                    this.fill();
                } else {
                    console.log('Unknown answer on /api/order_create');
                }
            }


            // Отдаем ответ в компонент для вывода сообщений и пр.
            return reqResult;
        },

    }
})
